<script>
export default {
	name: "EllevioWebScrollBehaviour",
	data() {
		return {
			lastMainWidth: 0
		}
	},
	computed: {
		matchMediaMobileQuery() {
      return window.matchMedia(" (min-width: 900px) ");
    },
		isTouchEnabled() {
      return ( 'ontouchstart' in window ) || ( navigator.maxTouchPoints > 0 ) || ( navigator.msMaxTouchPoints > 0 );
    }
	},
	mounted: function() {
		this.isMobile =  this.matchMediaMobileQuery ? !this.matchMediaMobileQuery.matches : true;
    this.heightTransition(this.isMobile)
    this._boundedResize = this.resize.bind(this);
    window.addEventListener("resize", this._boundedResize);
	},
	unmounted() {
    window.removeEventListener("resize", this._boundedResize);
  },
	methods: {
		heightTransition(isMobile) {
      const mainWidth = document.querySelector('main').offsetWidth
      const widthIsConstant = this.lastMainWidth > 0 ? mainWidth === this.lastMainWidth || Math.abs(mainWidth - this.lastMainWidth) > 300 : true
			const elementToModify = document.querySelectorAll(`[data-sitesection="sitesection-hero-large-image"]`)[0]

			/*
      console.log('elementToModify:', elementToModify)
      console.log('mainWidth:', mainWidth)
      console.log('lastMainWidth:', this.lastMainWidth)
      console.log('widthIsConstant:', widthIsConstant)
      console.log('isMobile:', isMobile)
      console.log('isTouchEnabled:', this.isTouchEnabled)
			*/

      if (mainWidth && widthIsConstant && isMobile && this.isTouchEnabled) { 
				if (elementToModify && !elementToModify.classList.contains('slowHeightTransition')) {
					elementToModify.classList.add("slowHeightTransition");
				}
      } else {
				if (elementToModify && elementToModify.classList.contains('slowHeightTransition')) {
					elementToModify.classList.remove("slowHeightTransition");
				}
      }
      this.lastMainWidth = mainWidth
    },
		resize: function () {
			this.isMobile =  this.matchMediaMobileQuery ? !this.matchMediaMobileQuery.matches : true;
      this.heightTransition(this.isMobile)
    }
	},
	render() {
		return null;
	}
}
</script>
